export default __webpack_public_path__ + "static/media/SpaceMono-Italic.08913052.ttf";